
import React from "react";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

interface FormTextAreaProps {
  id: string;
  label: string;
  required?: boolean;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  error?: string;
  minHeight?: string;
}

const FormTextArea: React.FC<FormTextAreaProps> = ({
  id,
  label,
  required = false,
  value,
  onChange,
  error,
  minHeight = "100px",
}) => {
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>
        {label} {required && "*"}
      </Label>
      <Textarea
        id={id}
        name={id}
        value={value}
        onChange={onChange}
        className={`min-h-[${minHeight}] ${error ? "border-red-500" : ""}`}
      />
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
};

export default FormTextArea;
